import { BaseResource } from '../core/base-resource';

export class LoyaltyHistoryRecord extends BaseResource {
  readonly date: string;
  readonly info: string;
  readonly key: number;
  readonly points: number;
  readonly type: string;
}
